// extracted by mini-css-extract-plugin
module.exports = {"bannersContainer":"StudioBanner_bannersContainer__3S06Q","paymentFailedContainer":"StudioBanner_paymentFailedContainer__2ycr5","container":"StudioBanner_container__3EUkh"};